<template>
  <b-row>
    <b-col>
      <b-button size="sm" @click="openOrClose()" variant="primary" block class="mt-1">
        {{ $t('buttons.taskHistory') }}
      </b-button>
      <b-collapse :visible="visible">
        <TaskHistory :items="items" :taskIndex="taskIndex"></TaskHistory>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import TaskHistory from './TaskHistory'

export default {
  name: 'TaskHistoryCollapse',
  props: {
    taskIndex: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      visible: false
    }
  },
  components: {
    TaskHistory
  },
  methods: {
    openOrClose () {
      if (this.visible === false) {
        this.visible = true
      } else {
        this.visible = false
      }
    }
  }
}
</script>
